<!-- The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work. -->
<template>
  <div class="md:min-h-screen">
    <!-- 筛选区域 -->
    <div class="container mx-auto px-8 py-6 hidden md:block">
      <!-- 面包屑 -->
      <div class="flex items-center text-sm text-gray-500 mb-6">
        <span class="cursor-pointer hover:text-blue-600">首页</span>
        <i class="fas fa-chevron-right mx-2 text-xs"></i>
        <span class="cursor-pointer hover:text-blue-600">商品列表</span>
      </div>
      <!-- 筛选条件 -->
      <div class="space-y-4">
        <div class="flex flex-col gap-4">
          <div class="flex items-center gap-6">
            <span class="text-gray-600 w-30">商品分类:</span>
            <div class="flex flex-wrap gap-4">
              <button
                v-for="category in categories"
                :key="category"
                :class="{ 'bg-blue-50 text-blue-600': selectedCategories.includes(category) }"
                @click="toggleCategory(category)"
                class="px-4 py-2 rounded-button text-sm hover:bg-blue-50 cursor-pointer whitespace-nowrap"
              >
                {{ category }}
              </button>
            </div>
          </div>
          
          <!-- 用途筛选 -->
          <div class="flex items-center gap-6">
            <span class="text-gray-600 w-30">使用场景:</span>
            <div class="flex flex-wrap gap-4">
              <button
                v-for="purpose in purposes"
                :key="purpose"
                :class="{ 'bg-blue-50 text-blue-600': selectedPurposes.includes(purpose) }"
                @click="togglePurpose(purpose)"
                class="px-4 py-2 rounded-button text-sm hover:bg-blue-50 cursor-pointer whitespace-nowrap"
              >
                {{ purpose }}
              </button>
            </div>
          </div>
          
          <!-- 预设价格区间选择 -->
          <div class="flex items-center gap-6">
            <span class="text-gray-600 w-30">价格区间:</span>
            <div class="flex flex-wrap gap-4">
              <button
                v-for="range in priceRanges"
                :key="range.label"
                :class="{ 'bg-blue-50 text-blue-600': isSelectedPriceRange(range) }"
                @click="selectPriceRange(range)"
                class="px-4 py-2 rounded-button text-sm hover:bg-blue-50 cursor-pointer whitespace-nowrap"
              >
                {{ range.label }}
              </button>
            </div>
          </div>
        </div>
        <!-- 自定义价格区间输入 -->
        <div class="flex items-center gap-6">
          <span class="text-gray-600 w-30">自定义价格:</span>
          <div class="flex items-center gap-3">
            <input
              v-model="priceRange.min"
              type="text"
              class="w-24 px-3 py-2 border rounded-lg text-sm"
              placeholder="最低价"
            />
            <span>-</span>
            <input
              v-model="priceRange.max"
              type="text"
              class="w-24 px-3 py-2 border rounded-lg text-sm"
              placeholder="最高价"
            />
          </div>
        </div>
        <div class="flex items-center gap-6">
          <span class="text-gray-600 w-30">搜索:</span>
          <div class="relative flex-1 max-w-md">
            <input
              v-model="searchQuery"
              type="text"
              class="w-full pl-10 pr-4 py-2 border rounded-lg text-sm"
              placeholder="搜索商品"
            />
            <i
              class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            ></i>
          </div>
        </div>
      </div>
      <!-- 已选条件 -->
      <div
        class="flex flex-wrap gap-2 mt-6"
        v-if="selectedCategories.length > 0 || selectedPurposes.length > 0 || searchQuery || priceRange.min || priceRange.max">
        <!-- 选中的分类 -->
        <div
          v-for="category in selectedCategories"
          :key="`category-${category}`"
          class="flex items-center bg-blue-50 px-3 py-1 rounded-full text-sm text-blue-600"
        >
          <span>分类: {{ category }}</span>
          <i
            class="fas fa-times ml-2 cursor-pointer"
            @click="clearSelectedCategory(category)"
          ></i>
        </div>
        
        <!-- 选中的用途 -->
        <div
          v-for="purpose in selectedPurposes"
          :key="`purpose-${purpose}`"
          class="flex items-center bg-blue-50 px-3 py-1 rounded-full text-sm text-blue-600"
        >
          <span>场景: {{ purpose }}</span>
          <i
            class="fas fa-times ml-2 cursor-pointer"
            @click="clearSelectedPurpose(purpose)"
          ></i>
        </div>
        
        <!-- 搜索条件 -->
        <div
          v-if="searchQuery"
          class="flex items-center bg-blue-50 px-3 py-1 rounded-full text-sm text-blue-600"
        >
          <span>搜索: {{ searchQuery }}</span>
          <i
            class="fas fa-times ml-2 cursor-pointer"
            @click="clearSearchQuery"
          ></i>
        </div>
        
        <!-- 价格区间条件 -->
        <div
          v-if="priceRange.min || priceRange.max"
          class="flex items-center bg-blue-50 px-3 py-1 rounded-full text-sm text-blue-600"
        >
          <span>价格: {{ priceRange.min || '0' }}-{{ priceRange.max || '不限' }}</span>
          <i
            class="fas fa-times ml-2 cursor-pointer"
            @click="clearPriceRange"
          ></i>
        </div>
        
        <!-- 清除全部按钮 -->
        <button
          @click="resetFilters"
          class="flex items-center bg-gray-100 px-3 py-1 rounded-full text-sm text-gray-600 hover:bg-gray-200"
        >
          <i class="fas fa-times mr-1"></i>
          <span>清除全部</span>
        </button>
      </div>
    </div>


    <!-- 手机端筛选 -->
    <div
      class="md:hidden left-0 right-0  px-4 py-3 flex justify-between items-center z-10 border-b border-gray-100"
    >
      <button
        @click="toggleFilter(true)"
        class="flex items-center space-x-2 px-3 py-2 bg-white rounded-lg border border-gray-200 cursor-pointer !rounded-button"
      >
        <i class="fas fa-filter text-gray-600 text-sm"></i>
        <span class="text-sm text-gray-700">筛选</span>
      </button>
      <span class="text-sm text-gray-600">共 {{ totalProducts }} 件商品</span>
    </div>
  
    <!-- 商品列表 -->
    <div class="container mx-auto px-8 py-6">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div
          v-for="product in displayProducts"
          :key="product.id"
          class="group bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
        >
          <div class="relative aspect-square overflow-hidden rounded-t-lg">
            <img
              :src="product.image"
              :alt="product.name"
              class="w-full h-full object-cover object-top"
            />
            <div
              class="absolute inset-0 bg-black bg-opacity-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center"
            >

              <router-link :to="{ path: `/product/${product.id}`, query: { type: route.query.type } }" class="inline-block">
                <button
                  class="bg-white text-gray-800 px-6 py-2 rounded-button text-sm font-medium cursor-pointer whitespace-nowrap"
                >
                  查看详情
                </button>
              </router-link>

            </div>
          </div>
          <div class="p-4">
            <h3 class="text-lg font-medium mb-2">{{ product.name }}</h3>
            <p class="text-gray-600 text-sm mb-2 line-clamp-2">
              {{ product.description }}
            </p>
            <div class="flex items-center justify-between">
              <div class="flex items-center space-x-2">
                <span v-if="product.discountPrice && product.discountPrice > 0 && product.discountPrice < (product.price || 0)" class="text-gray-400 text-sm line-through">¥{{ product.price || 0 }}</span>
                <span class="text-red-600 font-medium">¥{{ (product.discountPrice && product.discountPrice > 0 && product.discountPrice < (product.price || 0)) ? product.discountPrice : (product.price || 0) }}</span>
              </div>
              <div class="flex items-center">
                <i class="fas fa-star text-yellow-400"></i>
                <span class="ml-1 text-sm text-gray-600"
                  >{{ product.rating }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div
      class="container mx-auto px-8 py-8 flex justify-center items-center gap-2">
      <button
        class="px-4 py-2 rounded-button text-sm bg-gray-100 hover:bg-gray-200 cursor-pointer whitespace-nowrap"
        :disabled="currentPage === 1"
        @click="currentPage--"
      >
        上一页
      </button>
      <button
        v-for="page in totalPages"
        :key="page"
        :class="{ 'bg-blue-600 text-white': currentPage === page }"
        @click="currentPage = page"
        class="w-10 h-10 rounded-button flex items-center justify-center text-sm hover:bg-gray-100 cursor-pointer whitespace-nowrap"
      >
        {{ page }}
      </button>
      <button
        class="px-4 py-2 rounded-button text-sm bg-gray-100 hover:bg-gray-200 cursor-pointer whitespace-nowrap"
        :disabled="currentPage === totalPages"
        @click="currentPage++"
      >
        下一页
      </button>
    </div>

    <!-- 筛选弹窗 -->
    <div v-if="showFilter" class="fixed inset-0 z-50 overflow-hidden">
      <!-- 遮罩层 -->
      <div
        class="absolute inset-0 bg-black bg-opacity-50"
        @click="toggleFilter(false)"
      ></div>
      <!-- 弹窗内容 -->
      <div
        class="absolute right-0 top-0 h-full w-2/3 bg-white transform transition-transform duration-300"
        :class="{ 'translate-x-0': showFilter, 'translate-x-full': !showFilter }"
      >
        <!-- 弹窗头部 -->
        <div
          class="flex justify-between items-center px-4 py-4 border-b border-gray-100"
        >
          <h2 class="text-lg font-semibold text-gray-900">筛选条件</h2>
          <button @click="toggleFilter(false)" class="p-2 cursor-pointer">
            <i class="fas fa-times text-gray-500"></i>
          </button>
        </div>
        <!-- 弹窗内容区 -->
        <div class="h-[calc(100%-8rem)] overflow-y-auto px-4 py-4 pb-24">
          <!-- 搜索框 -->
          <div class="mb-6">
            <div class="relative">
              <input
                v-model="searchQuery"
                type="text"
                placeholder="搜索商品..."
                class="w-full pl-10 pr-10 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-blue-500"
              />
              <i
                class="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"
              ></i>
              <button
                v-if="searchQuery"
                @click="clearSearchQuery"
                class="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
              >
                <i class="fas fa-times text-gray-400 text-sm"></i>
              </button>
            </div>
          </div>
          <!-- 商品分类 -->
          <div class="mb-6">
            <h3 class="text-base font-medium text-gray-900 mb-3">商品分类</h3>
            <div class="grid grid-cols-2 gap-2">
              <button
                v-for="category in categories"
                :key="category"
                @click="toggleCategory(category)"
                :class="{
                        'bg-blue-500 text-white border-blue-500': selectedCategories.includes(category),
                        'bg-white text-gray-700 border-gray-200': !selectedCategories.includes(category)
                        }"
                class="px-3 py-2 border rounded-lg text-sm cursor-pointer !rounded-button"
              >
                {{ category }}
              </button>
            </div>
          </div>
          <!-- 用途分类 -->
          <div class="mb-6">
            <h3 class="text-base font-medium text-gray-900 mb-3">用途分类</h3>
            <div class="grid grid-cols-2 gap-2">
              <button
                v-for="purpose in purposes"
                :key="purpose"
                @click="togglePurpose(purpose)"
                :class="{
                        'bg-blue-500 text-white border-blue-500': selectedPurposes.includes(purpose),
                        'bg-white text-gray-700 border-gray-200': !selectedPurposes.includes(purpose)
                        }"
                class="px-3 py-2 border rounded-lg text-sm cursor-pointer !rounded-button"
              >
                {{ purpose }}
              </button>
            </div>
          </div>
          <!-- 价格区间 -->
          <div class="mb-6">
            <h3 class="text-base font-medium text-gray-900 mb-3">价格区间</h3>
            <div class="grid grid-cols-2 gap-3 mb-3">
              <input
                v-model="priceRange.min"
                type="number"
                placeholder="最低价"
                class="px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-blue-500"
              />
              <input
                v-model="priceRange.max"
                type="number"
                placeholder="最高价"
                class="px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-blue-500"
              />
            </div>
            <div class="grid grid-cols-2 gap-2">
              <button
                v-for="range in priceRanges"
                :key="range.label"
                @click="selectPriceRange(range)"
                :class="{
                        'bg-blue-500 text-white border-blue-500': isSelectedPriceRange(range),
                        'bg-white text-gray-700 border-gray-200': !isSelectedPriceRange(range)
                        }"
                class="px-3 py-2 border rounded-lg text-sm cursor-pointer !rounded-button"
              >
                {{ range.label }}
              </button>
            </div>
          </div>
        </div>
        <!-- 底部操作栏 -->
        <div
          class="border-t border-gray-100 px-4 py-4 absolute bottom-0 left-0 right-0 bg-white"
        >
          <div class="flex space-x-3">
            <button
              @click="resetFilters"
              class="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-lg text-sm cursor-pointer !rounded-button"
            >
              重置
            </button>
            <button
              @click="applyFilters"
              class="flex-1 px-4 py-3 bg-blue-500 text-white rounded-lg text-sm cursor-pointer !rounded-button"
            >
              确认
            </button>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from "vue";
// 导入路由相关
import { useRoute, useRouter } from 'vue-router';
// 导入响应式相关
import { watch } from 'vue';
// 商品s筛选
// const categories = [
//   "全部商品",
//   "自行车",
//   "运动装备",
//   "配饰",
//   "背包",
//   "运动服装",
// ];
// 当前页
const currentPage = ref(1);
// 搜索框
const searchQuery = ref("");
// 价格区间
const priceRange = ref({
  min: "",
  max: "",
});
// 选中的分类（多选，移动端和桌面端共用）
const selectedCategories = ref<string[]>([]);
// 选中的用途（多选，移动端和桌面端共用）
const selectedPurposes = ref<string[]>([]);
// 分类数据
const categories = [
  "头盔",
  "服饰",
  "山地车",
  "公路车",
  "折叠车",
  "儿童车",
  "骑行服",
  "骑行裤",
  "手套",
  "眼镜",
  "水壶",
  "车灯",
];
// 用途数据
const purposes = [
  "休闲骑行",
  "竞技比赛",
  "通勤代步",
  "越野探险",
  "健身运动",
  "亲子出行",
];
// 预设价格区间
const priceRanges = [
  { label: "100-500", min: 100, max: 500 },
  { label: "500-1000", min: 500, max: 1000 },
  { label: "1000-3000", min: 1000, max: 3000 },
  { label: "3000以上", min: 3000, max: 99999 },
];

// 导入产品数据API
import { getProductList } from '../api/product.js';

// 获取路径参数
interface RouteParams {
  type: string;
}

const route = useRoute<RouteParams>();
const loading = ref(false);
const error = ref(null);

// 获取产品列表数据的函数
const fetchProducts = async (typeParam) => {
  loading.value = true;
  error.value = null;
  try {
    // 调用API获取产品列表，传入type参数
    const data = await getProductList(typeParam);
    products.value = data;
  } catch (err) {
    error.value = '获取产品列表失败';
    console.error('获取产品列表错误:', err);
  } finally {
    loading.value = false;
  }
};

// 商品列表响应式数据
const products = ref([]);

// 初始化加载产品数据
fetchProducts(route.query.type);

// 监听路由参数变化，当type参数改变时更新产品数据
watch(
  () => route.query.type,
  (newType) => {
    fetchProducts(newType);
  },
  { immediate: true }
);

// 过滤产品，使用统一的筛选条件
const filteredProducts = computed(() => {
  let result = [...products.value];
  
  // 分类筛选（多选）
  if (selectedCategories.value.length > 0) {
    result = result.filter((product) => {
      return selectedCategories.value.includes(product.category);
    });
  }
  
  // 用途筛选（多选）
  if (selectedPurposes.value.length > 0) {
    result = result.filter((product) => {
      return product.purposes && product.purposes.some(purpose => 
        selectedPurposes.value.includes(purpose)
      );
    });
  }
  
  // 搜索筛选
  if (searchQuery.value) {
    result = result.filter(
      (product) =>
        product.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        product.description
          .toLowerCase()
          .includes(searchQuery.value.toLowerCase()),
    );
  }
  
  // 价格区间筛选
  if (priceRange.value.min) {
    result = result.filter(
      (product) => {
        // 使用实际显示的价格（折扣价或原价）进行筛选
        const displayPrice = product.discountPrice && product.discountPrice > 0 && product.discountPrice < product.price ? product.discountPrice : product.price;
        return displayPrice >= Number(priceRange.value.min);
      },
    );
  }
  if (priceRange.value.max) {
    result = result.filter(
      (product) => {
        // 使用实际显示的价格（折扣价或原价）进行筛选
        const displayPrice = product.discountPrice && product.discountPrice > 0 && product.discountPrice < product.price ? product.discountPrice : product.price;
        return displayPrice <= Number(priceRange.value.max);
      },
    );
  }
  
  return result;
});
// 每页显示的产品数量
const itemsPerPage = 8;
// 总页数
const totalPages = computed(() =>
  Math.ceil(filteredProducts.value.length / itemsPerPage),
);
// 展示的商品数据
const displayProducts = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return filteredProducts.value.slice(start, end);
});

// 筛选面板控制
const showFilter = ref(false);
const toggleFilter = (value: boolean) => {
  showFilter.value = value;
  if (value) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
};
// 重置所有筛选条件
const resetFilters = () => {
  searchQuery.value = "";
  selectedCategories.value = [];
  selectedPurposes.value = [];
  priceRange.value = { min: "", max: "" };
  currentPage.value = 1;
};
// 应用筛选条件（移动端关闭筛选面板）
const applyFilters = () => {
  showFilter.value = false;
  currentPage.value = 1;
};
// 计算总商品数（共用）
const totalProducts = computed(() => filteredProducts.value.length);

// 移动端显示的商品数据
const currentProducts = computed(() => {
  const start = (currentPage.value - 1) * 6;
  const end = start + 6;
  return filteredProducts.value.slice(start, end);
});
const paginationPages = computed(() => {
  const pages = [];
  const total = totalPages.value;
  if (total <= 3) {
    for (let i = 1; i <= total; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1, 2, 3);
    if (total > 3) {
      pages.push("...");
      pages.push(total);
    }
  }
  return pages;
});
// 切换分类选择状态
const toggleCategory = (category: string) => {
  const index = selectedCategories.value.indexOf(category);
  if (index > -1) {
    selectedCategories.value.splice(index, 1);
  } else {
    selectedCategories.value.push(category);
  }
  currentPage.value = 1; // 切换筛选条件时重置到第一页
};

// 选择预设价格区间
const selectPriceRange = (range: {
  label: string;
  min: number;
  max: number;
}) => {
  priceRange.value.min = range.min.toString();
  priceRange.value.max = range.max === 99999 ? "" : range.max.toString();
  currentPage.value = 1; // 切换筛选条件时重置到第一页
};

// 检查价格区间是否被选中
const isSelectedPriceRange = (range: {
  label: string;
  min: number;
  max: number;
}) => {
  const minMatch = priceRange.value.min === range.min.toString();
  const maxMatch = 
    range.max === 99999
      ? priceRange.value.max === ""
      : priceRange.value.max === range.max.toString();
  return minMatch && maxMatch;
};

// 切换用途选择状态
const togglePurpose = (purpose: string) => {
  const index = selectedPurposes.value.indexOf(purpose);
  if (index > -1) {
    selectedPurposes.value.splice(index, 1);
  } else {
    selectedPurposes.value.push(purpose);
  }
  currentPage.value = 1; // 切换筛选条件时重置到第一页
};

// 清除单个筛选条件的辅助方法
const clearSelectedCategory = (category: string) => {
  const index = selectedCategories.value.indexOf(category);
  if (index > -1) {
    selectedCategories.value.splice(index, 1);
  }
  currentPage.value = 1;
};

const clearSelectedPurpose = (purpose: string) => {
  const index = selectedPurposes.value.indexOf(purpose);
  if (index > -1) {
    selectedPurposes.value.splice(index, 1);
  }
  currentPage.value = 1;
};

const clearPriceRange = () => {
  priceRange.value = { min: "", max: "" };
  currentPage.value = 1;
};

const clearSearchQuery = () => {
  searchQuery.value = ""; 
  currentPage.value = 1;
};
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
input[type="text"] {
  outline: none;
}
input[type="text"]:focus {
  border-color: #2563eb;
  ring: 2px;
  ring-color: #93c5fd;
}
</style>
